import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import ProductDetails from "../customer/Components/Product/ProductDetails/ProductDetails";
import Product from "../customer/Components/Product/Product/Product";
import Contact from "../Pages/Contact";
import TearmsCondition from "../Pages/TermsAndConditions";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import About from "../Pages/About";
import Homepage from "../Pages/Homepage";
import Navigation from "../customer/Components/Navbar/Navigation";
import Cart from "../customer/Components/Cart/Cart";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Button } from "@mui/material";
import { customTheme, customerTheme } from "../Admin/them/customeThem";
import Order from "../customer/Components/orders/Order";
import OrderDetails from "../customer/Components/orders/OrderDetails";
import TrackOrder from "../customer/Components/orders/TrackOrder";
import Checkout from "../customer/Components/Checkout/Checkout";
import Footer from "../customer/Components/footer/Footer";
import PaymentSuccess from "../customer/Components/paymentSuccess/PaymentSuccess";
import RateProduct from "../customer/Components/ReviewProduct/RateProduct";
import Wishlist from "../customer/Components/WhishList/Wishlist";
import Blogs from "../Pages/Blogs";
import ContactPage from "../Pages/ContactPage";
import whatsappimg from '../whatsapp (1).png'
import SidebarCart from "../Pages/SidebarCart";
import Bulkorder from "../Pages/Bulkorder";
import Checkouts from "../Pages/Checkout";
import ScrollToTop from "./ScrollToTop";
import BlueDartWaybillGenerator from "../Pages/BlueDartWaybillGenerator";
import OrderSummary from "../customer/Components/Checkout/OrderSummary";
import ReturnsPolicy from "../Pages/ReturnsPolicy";
import ShippingPolicy from "../Pages/ShippingPolicy";
import UserProfile from "../Pages/UserProfile";

const CustomerRoutes = () => {
  const location = useLocation();
 useEffect(() => {
  sessionStorage.removeItem("hasReloaded");
}, []);
  // Only show Navigation component when not on the NotFound page
  const showNavigation = location.pathname !== "*";

  // const path=["/","/home","/about","/privacy-policy","/terms-condition","/contact","/men",`/product/${productId}`]
  return (
 
    <div>
      <ThemeProvider theme={customerTheme}>
              <ScrollToTop />
        {showNavigation && <Navigation />}
        <Routes>
          <Route path="/login" element={<Homepage />}></Route>
          <Route path="/register" element={<Homepage />}></Route>

          <Route path="/" element={<Homepage />}></Route>
          <Route path="/home" element={<Homepage />}></Route>
          {/* <Route path="/bytpdf" element={<ByteArrayToPdf/>}></Route> */}
          <Route path="/about" element={<About />}></Route>
          <Route path="/privaciy-policy" element={<PrivacyPolicy />}></Route>
          <Route path="/terms-condition" element={<TearmsCondition />}></Route>
          <Route path="/shipping-policy" element={<ShippingPolicy />}></Route>
          <Route path="/returns-policy" element={<ReturnsPolicy />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
          <Route path="/waytobill/:orderId" element={<BlueDartWaybillGenerator/>} ></Route>
          <Route path='/ordersummary' element={OrderSummary}></Route>
          <Route
            path="/:lavelOne/:lavelTwo/:lavelThree"
            element={<Product />}
          ></Route>
            <Route    
            path="/products"
            element={<Product />}
          ></Route>
          <Route
            path="/product/:productId"
            element={<ProductDetails />}
          ></Route>
          <Route
            path="/productDetails"
            element={<ProductDetails />}
          ></Route>
          {/* <Route pah="/user-profile" element={<UserProfile/>}></Route> */}
          <Route path="/cart" element={<Cart />}></Route>
          <Route path="/wish-item" element={<Wishlist/>}></Route>
          <Route path="/user-profile" element={<UserProfile/>}></Route>
          <Route path="/account/order" element={<Order />}></Route>
          <Route
            path="/account/order/:orderId"
            element={<OrderDetails />}
          ></Route>
          <Route
            path="/account/order/:orderId/track"
            element={<TrackOrder />}
          ></Route>
          <Route
            path="/account/rate/:productId"
            element={<RateProduct />}
          ></Route>
          <Route path="/checkout" element={<Checkout />}></Route>
          <Route path="/payment/:orderId" element={<PaymentSuccess />}></Route>
           <Route path="/blog" element={<Blogs/>} >  </Route>
              <Route path="/ContactPage" element={<ContactPage/>} >  </Route>
            <Route path="/slider" element={<SidebarCart/>} ></Route>
            <Route path="/bulk-order" element={<Bulkorder/>} ></Route>
            <Route path="/check"  elemen={<Checkouts/>}></Route>
            
           
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
       
        <Footer />
      </ThemeProvider>
         {/* WhatsApp Floating Button */}
            <a
              href="https://wa.me/918827373432" // Replace with your WhatsApp number
              target="_blank"
              rel="noopener noreferrer"
              style={{
                position: "fixed",
                bottom: "20px",
                right: "20px",
                zIndex: 1000,
              }}
            >
              <img
                src={whatsappimg}
                alt="WhatsApp Chat"
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                }}
              />
            </a>
    </div>
  );
};

export default CustomerRoutes;
